<template>
  <div style="position: relative;">
    <footer
      v-if="data.showFooter"
      class="rn-footer footer-style-default footer-style-1"
      style="opacity: 0.5;"
    >
      <div class="footer-top" style="padding: 15px 0px">
        <div class="container">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div>
              <img :src="logo" style="width: 105px; height: 61px" />
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div>
                <div>Community</div>
                <div style="display: flex; align-items: center">
                  <div style="margin-right: 35px;">
                    <a href="https://twitter.com/Augusta_finance">
                      <img
                        style="width: 46px; height: 46px; margin-right: 10px"
                        src="../../../assets/images/icons/twitter-w.svg"
                        alt="Twitter"
                      />Twitter
                    </a>
                  </div>
                  <div>
                    <a href="https://discord.gg/Pk6n6RSy">
                      <img
                        style="width: 46px; height: 46px; margin-right: 10px"
                        src="../../../assets/images/icons/discord-w.svg"
                        alt="Discord"
                      />Discord
                    </a>
                  </div>
                </div>
              </div>
              <div style="width: 1px;background: rgba(255, 255, 255, 0.17);height: 30px;margin: 0px 158px;"></div>
              <div>
                <div>Resources</div>
                <div>
                  <a href="https://augusta-finance.gitbook.io">Doc</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <ScrollTop />
  </div>
</template>

<script>
import CopyrightTwo from './CopyrightTwo'
import CallToAction from '../../elements/callToAction/CallToAction'
import ScrollTop from './ScrollTop'

export default {
  name: 'FooterTwo',
  components: { CallToAction, CopyrightTwo, ScrollTop },
  props: {
    data: {
      default: null,
    },
  },
  data() {
    return {
      logo: require('../../../assets/images/logo/logo-footer.png'),
    }
  },
}
</script>
